import { render } from "./BodyText.vue?vue&type=template&id=7c3908e4"
import script from "./BodyText.vue?vue&type=script&lang=js"
export * from "./BodyText.vue?vue&type=script&lang=js"

import "./BodyText.vue?vue&type=style&index=0&id=7c3908e4&lang=css"

import exportComponent from "/var/www/staging.no-menu.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__